import axios from 'axios';
import { getBaseUrl, refreshToken } from './helpers';

// API Endpoints
const GET_SAVINGS_SUMMARY_ENDPOINT = `/building/api/contracts/summary/`;
const GET_DATES_ENDPOINT = `/building/api/contracts/dates/`;
const GET_REPORTS_ENDPOINT = `/building/api/contracts/reports/`;
const GET_BUILDINGS_REPORTS_ENDPOINT = `/building/api/contracts/building_reports/`;
const GET_INCENTIVES_ENDPOINT = `/building/api/incentives/`;


export const getSavingsSummary = (env, identifier) => {
  const BASE_URL = getBaseUrl(env);
  let authToken = JSON.parse(sessionStorage.getItem('token')) || '';

  if (!authToken) {
    refreshToken(env);

    authToken = JSON.parse(sessionStorage.getItem('token')) || '';
  }

  const response = axios
    .get(`${BASE_URL}${GET_SAVINGS_SUMMARY_ENDPOINT}${identifier}/`, {
      headers: {
        'Authorization': `JWT ${authToken}`,
        'Content-Type': 'application/json',
      },
    })
    .then((response) => {
      return response.data;
    })
    .catch(async (error) => {
      if (error.response.status === 401) {
        refreshToken(env);

        return getSavingsSummary(env, identifier);
      }
      return Promise.reject(error.response.data.errors[0].message);
    });

  return response;
}

export const getCumulativeSavings = (env, identifier) => {
const BASE_URL = getBaseUrl(env);
  let authToken = JSON.parse(sessionStorage.getItem('token')) || '';

  if (!authToken) {
    refreshToken(env);

    authToken = JSON.parse(sessionStorage.getItem('token')) || '';
  }

  const response = axios
    .get(`${BASE_URL}${GET_SAVINGS_SUMMARY_ENDPOINT}${identifier}/cumulative/`, {
      headers: {
        'Authorization': `JWT ${authToken}`,
        'Content-Type': 'application/json',
      },
    })
    .then((response) => {
      return response.data;
    })
    .catch(async (error) => {
      if (error.response.status === 401) {
        refreshToken(env);

        return getCumulativeSavings(env, identifier);
      }
      return Promise.reject(error.response.data.errors[0].message);
    });

  return response;
}

export const getEnvironmentalImpact = (env, identifier) => {
  const BASE_URL = getBaseUrl(env);
  let authToken = JSON.parse(sessionStorage.getItem('token')) || '';

  if (!authToken) {
    refreshToken(env);

    authToken = JSON.parse(sessionStorage.getItem('token')) || '';
  }
  
  const response = axios
    .get(`${BASE_URL}${GET_SAVINGS_SUMMARY_ENDPOINT}${identifier}/environmental/`, {
      headers: {
        'Authorization': `JWT ${authToken}`,
        'Content-Type': 'application/json',
      },
    })
    .then((response) => {
      return response.data;
    })
    .catch(async (error) => {
      if (error.response.status === 401) {
        refreshToken(env);

        return getEnvironmentalImpact(env, identifier);
      }
      return Promise.reject(error.response.data.errors[0].message);
    });

  return response;
}

export const getMonthlySavings = (env, identifier, date = '') => {
  const BASE_URL = getBaseUrl(env);
  let authToken = JSON.parse(sessionStorage.getItem('token')) || '';

  if (!authToken) {
    refreshToken(env);

    authToken = JSON.parse(sessionStorage.getItem('token')) || '';
  }
  
  const response = axios
    .get(`${BASE_URL}${GET_SAVINGS_SUMMARY_ENDPOINT}${identifier}/monthly/?date=${date}`, {
      headers: {
        'Authorization': `JWT ${authToken}`,
        'Content-Type': 'application/json',
      },
    })
    .then((response) => {
      return response.data;
    })
    .catch(async (error) => {
      if (error.response.status === 401) {
        refreshToken(env);

        return getMonthlySavings(env, identifier);
      }
      return Promise.reject(error.response.data.errors[0].message);
    });

  return response;
}

export const getAnnualSavings = (env, identifier, date = '') => {
  const BASE_URL = getBaseUrl(env);
  let authToken = JSON.parse(sessionStorage.getItem('token')) || '';

  if (!authToken) {
    refreshToken(env);

    authToken = JSON.parse(sessionStorage.getItem('token')) || '';
  }
  
  const response = axios
    .get(`${BASE_URL}${GET_SAVINGS_SUMMARY_ENDPOINT}${identifier}/annual/?date=${date}`, {
      headers: {
        'Authorization': `JWT ${authToken}`,
        'Content-Type': 'application/json',
      },
    })
    .then((response) => {
      return response.data;
    })
    .catch(async (error) => {
      if (error.response.status === 401) {
        refreshToken(env);

        return getAnnualSavings(env, identifier);
      }
      return Promise.reject(error.response.data.errors[0].message);
    });

  return response;
}

export const getSavingsComparison = (env, identifier, utility, date = '') => {
  const BASE_URL = getBaseUrl(env);
  let authToken = JSON.parse(sessionStorage.getItem('token')) || '';

  if (!authToken) {
    refreshToken(env);

    authToken = JSON.parse(sessionStorage.getItem('token')) || '';
  }
  
  const response = axios
    .get(`${BASE_URL}${GET_SAVINGS_SUMMARY_ENDPOINT}${identifier}/monthly-comparison/?utility=${utility}&date=${date}`, {
      headers: {
        'Authorization': `JWT ${authToken}`,
        'Content-Type': 'application/json',
      },
    })
    .then((response) => {
      return response.data;
    })
    .catch(async (error) => {
      if (error.response.status === 401) {
        refreshToken(env);

        return getSavingsComparison(env, identifier, utility, date);
      }
      return Promise.reject(error.response.data.errors[0].message);
    });

  return response;
}

export const getSavingsReports = (env, building) => {
  const BASE_URL = getBaseUrl(env);
  let authToken = JSON.parse(sessionStorage.getItem('token')) || '';

  if (!authToken) {
    refreshToken(env);

    authToken = JSON.parse(sessionStorage.getItem('token')) || '';
  }

  const response = axios
    .get(`${BASE_URL}${GET_REPORTS_ENDPOINT}${building}/`, {
      headers: {
        'Authorization': `JWT ${authToken}`,
        'Content-Type': 'application/json',
      },
    })
    .then((response) => {
      return response.data;
    })
    .catch(async (error) => {
      if (error.response.status === 401) {
        refreshToken(env);

        return getSavingsReports(env, building);
      }
      return Promise.reject(error.response.data.errors[0].message);
    });

  return response;
}

export const getBuildingsReports = (env, building) => {
  const BASE_URL = getBaseUrl(env);
  let authToken = JSON.parse(sessionStorage.getItem('token')) || '';

  if (!authToken) {
    refreshToken(env);

    authToken = JSON.parse(sessionStorage.getItem('token')) || '';
  }

  const response = axios
    .get(`${BASE_URL}${GET_BUILDINGS_REPORTS_ENDPOINT}${building}/`, {
      headers: {
        'Authorization': `JWT ${authToken}`,
        'Content-Type': 'application/json',
      },
    })
    .then((response) => {
      return response.data;
    })
    .catch(async (error) => {
      if (error.response.status === 401) {
        refreshToken(env);

        return getBuildingsReports(env, building);
      }
      return Promise.reject(error.response.data.errors[0].message);
    });

  return response;
}

export const getMonthlySavingsDates = (env, identifier) => {
  const BASE_URL = getBaseUrl(env);
  let authToken = JSON.parse(sessionStorage.getItem('token')) || '';

  if (!authToken) {
    refreshToken(env);

    authToken = JSON.parse(sessionStorage.getItem('token')) || '';
  }
  
  const response = axios
    .get(`${BASE_URL}${GET_DATES_ENDPOINT}${identifier}/monthly/`, {
      headers: {
        'Authorization': `JWT ${authToken}`,
        'Content-Type': 'application/json',
      },
    })
    .then((response) => {
      return response.data.valid_dates;
    })
    .catch(async (error) => {
      if (error.response.status === 401) {
        refreshToken(env);

        return getMonthlySavingsDates(env, identifier);
      }
      return Promise.reject(error.response.data.errors[0].message);
    });

  return response;
}

export const getAnnualSavingsDates = (env, identifier) => {
  const BASE_URL = getBaseUrl(env);
  let authToken = JSON.parse(sessionStorage.getItem('token')) || '';

  if (!authToken) {
    refreshToken(env);

    authToken = JSON.parse(sessionStorage.getItem('token')) || '';
  }
  
  const response = axios
    .get(`${BASE_URL}${GET_DATES_ENDPOINT}${identifier}/annual/`, {
      headers: {
        'Authorization': `JWT ${authToken}`,
        'Content-Type': 'application/json',
      },
    })
    .then((response) => {
      return response.data.valid_dates;
    })
    .catch(async (error) => {
      if (error.response.status === 401) {
        refreshToken(env);

        return getAnnualSavingsDates(env, identifier);
      }
      return Promise.reject(error.response.data.errors[0].message);
    });

  return response;
}

export const getUtilityRates = (env, identifier) => {
  const BASE_URL = getBaseUrl(env);
  let authToken = JSON.parse(sessionStorage.getItem('token')) || '';

  if (!authToken) {
    refreshToken(env);

    authToken = JSON.parse(sessionStorage.getItem('token')) || '';
  }
  
  const response = axios
    .get(`${BASE_URL}${GET_SAVINGS_SUMMARY_ENDPOINT}${identifier}/utility-rates/`, {
      headers: {
        'Authorization': `JWT ${authToken}`,
        'Content-Type': 'application/json',
      },
    })
    .then((response) => {
      return response.data;
    })
    .catch(async (error) => {
      if (error.response.status === 401) {
        refreshToken(env);

        return getUtilityRates(env, identifier);
      }
      return Promise.reject(error.response.data.errors[0].message);
    });

  return response;
}

export const getIncentiveByBuilding = (env, identifier) => {
  const BASE_URL = getBaseUrl(env);
  let authToken = JSON.parse(sessionStorage.getItem('token')) || '';

  if (!authToken) {
    refreshToken(env);

    authToken = JSON.parse(sessionStorage.getItem('token')) || '';
  }

  const response = axios
    .get(`${BASE_URL}${GET_INCENTIVES_ENDPOINT}building/${identifier}/`, {
      headers: {
        'Authorization': `JWT ${authToken}`,
        'Content-Type': 'application/json',
      },
    })
    .then((response) => {
      return response.data;
    })
    .catch(async (error) => {
      if (error.response.status === 401) {
        refreshToken(env);

        return getIncentiveByBuilding(env, identifier);
      }
      return Promise.reject(error.response.data.errors[0].message);
    })
  
  return response;
}

export const getIncentiveByContract = (env, identifier) => {
  const BASE_URL = getBaseUrl(env);
  let authToken = JSON.parse(sessionStorage.getItem('token')) || '';

  if (!authToken) {
    refreshToken(env);

    authToken = JSON.parse(sessionStorage.getItem('token')) || '';
  }

  const response = axios
    .get(`${BASE_URL}${GET_INCENTIVES_ENDPOINT}contract/${identifier}/`, {
      headers: {
        'Authorization': `JWT ${authToken}`,
        'Content-Type': 'application/json',
      },
    })
    .then((response) => {
      return response.data;
    })
    .catch(async (error) => {
      if (error.response.status === 401) {
        refreshToken(env);

        return getIncentiveByContract(env, identifier);
      }
      return Promise.reject(error.response.data.errors[0].message);
    })
  
  return response;
}

export const getShouldDisplayIncentives = (env, building) => {
  const BASE_URL = getBaseUrl(env);
  let authToken = JSON.parse(sessionStorage.getItem('token')) || '';

  if (!authToken) {
    refreshToken(env);

    authToken = JSON.parse(sessionStorage.getItem('token')) || '';
  }

  const response = axios
    .get(`${BASE_URL}${GET_INCENTIVES_ENDPOINT}building/${building}/display-incentives/`, {
      headers: {
        'Authorization': `JWT ${authToken}`,
        'Content-Type': 'application/json',
      },
    })
    .then((response) => {
      return response.data.display_incentives;
    })
    .catch(async (error) => {
      if (error.response.status === 401) {
        refreshToken(env);

        return getShouldDisplayIncentives(env, building);
      }
      return Promise.reject(error.response.data.errors[0].message);
    })
  
  return response;
}

export const getIncentiveDetails = (env, incentive_id) => {
  const BASE_URL = getBaseUrl(env);
  let authToken = JSON.parse(sessionStorage.getItem('token')) || '';

  if (!authToken) {
    refreshToken(env);

    authToken = JSON.parse(sessionStorage.getItem('token')) || '';
  }

  const response = axios
    .get(`${BASE_URL}${GET_INCENTIVES_ENDPOINT}${incentive_id}/`, {
      headers: {
        'Authorization': `JWT ${authToken}`,
        'Content-Type': 'application/json',
      },
    })
    .then((response) => {
      return response.data;
    })
    .catch(async (error) => {
      if (error.response.status === 401) {
        refreshToken(env);

        return getIncentiveDetails(env, incentive_id);
      }
      return Promise.reject(error.response.data.errors[0].message);
    })
  
  return response;
}
